import React from "react";

const GroupDisposition = ({
  groupDispData,
  selectedTab,
  handleTabClick,
  catDispData,
  selectedAccountRelatedTab,
  handleAccountRelatedTabClick,
  descDispValue
}) => {
  return (
    <>
        <div className="first-section">
            <div className="btn-1">
                <ul>
                    {groupDispData.slice(0, 3).map((group) => {
                    const { GL_DISP_GRP_ID, GL_DISP_GRP_NAME } = group;
                    return (
                        <li key={GL_DISP_GRP_ID}>
                            <span
                                className={`tab-link-2 cp ${selectedTab === `${GL_DISP_GRP_ID}` ? "active" : ""}`}
                                onClick={() => handleTabClick(GL_DISP_GRP_ID)}
                                val={GL_DISP_GRP_ID}
                            >
                                {GL_DISP_GRP_NAME}
                            </span>

                        </li>
                    );
                    })}
                </ul>
            </div>
            {selectedTab &&
                (selectedTab === "7" ||
                selectedTab === "8" ||
                selectedTab === "9") && (
                <div className="btn-2">
                    <ul>
                        {catDispData.map((categories) => {
                        const { GL_DISP_CAT_ID, GL_DISP_CAT_NAME,GL_DISP_CAT_CLOSURE_ID } = categories;
                        return (
                            <li key={GL_DISP_CAT_ID}>
                            <span
                                className={`tab-link-3 cp ${
                                selectedAccountRelatedTab === `${GL_DISP_CAT_ID}`
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                   handleAccountRelatedTabClick(GL_DISP_CAT_ID,GL_DISP_CAT_NAME,GL_DISP_CAT_CLOSURE_ID)
                                }
                                val={GL_DISP_CAT_ID}
                            >
                                {GL_DISP_CAT_NAME}
                            </span>
                            </li>
                        );
                        })}
                    </ul>
                </div>
            )}
        </div>
    </>
  );
};

export default GroupDisposition;
